// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScrollMonitor from 'react-scrollmonitor';
import head from 'lodash/head';

// $FlowFixMe: Cannot resolve module
import profileImage from './profile';

import {
  postNudgeResponse,
  impressNudge,
  dismissNudge,
  answerNudge
} from 'src/store/nudges/nudges';

import NavLink from 'src/components/NavLink/NavLink';

// $FlowFixMe: Cannot resolve module
import NudgeTemplate from './NudgeTemplate/NudgeTemplate';

import { TextLink } from 'seek-style-guide/react';

type Props = {
  nudges: Array<NudgeType>,
  position: number,
  postNudgeResponse: Function,
  dismissNudge: Function,
  answerNudge: Function,
  impressNudge: Function,
  nudgePostError?: boolean,
  currentNudgeIndex: number
};

const mapStateToProps = ({ nudges }) => ({
  nudges: nudges.nudges,
  currentNudgeIndex: nudges.currentNudgeIndex,
  nudgePostError: nudges.nudgePostError
});

const mapDispatchToProps = {
  postNudgeResponse,
  impressNudge,
  dismissNudge,
  answerNudge
};

class Nudge extends Component<Props> {
  props: Props;

  onDismiss = ({ nudgeId, isThankYouMessage }) => () => {
    this.props.dismissNudge();

    if (!isThankYouMessage && !this.props.nudgePostError) {
      this.props.postNudgeResponse({ nudgeId, ctaValue: 'Dismiss' });
    }
  };

  onCtaClick = ({ nudgeId, ctaValue }) => () => {
    this.props.answerNudge();
    this.props.postNudgeResponse({ nudgeId, ctaValue });
  };

  renderProfileTextLink = () => {
    const ProfileLinkComponent = props => (
      <TextLink chevron="right" {...props} />
    );
    return ProfileLinkComponent;
  };

  nudgeImpression = args => () => this.props.impressNudge(args);

  render() {
    const { nudges, currentNudgeIndex, position, nudgePostError } = this.props;
    const nudge = nudges[currentNudgeIndex];
    const isThankYouMessage =
      nudges.length && currentNudgeIndex === nudges.length;
    const { firstName } = head(nudges);

    if (!(nudge || isThankYouMessage)) {
      return null;
    }

    const baseTemplateProps = {
      isThankYouMessage,
      onCtaClick: this.onCtaClick,
      onDismiss: this.onDismiss
    };

    const getProfileLink = analytics => (
      <NavLink
        analytics={analytics}
        children="Go to profile"
        component={this.renderProfileTextLink()}
        location="/profile/me"
      />
    );

    const errorProps = {
      ...baseTemplateProps,
      prompt: (
        <span>
          There’s something wrong on our end.
          <br />
          We weren’t able to save your answer to your profile.
        </span>
      ),
      firstName,
      text: getProfileLink('nudge-error-profile')
    };

    const thanksProps = {
      ...baseTemplateProps,
      prompt: 'We’ve updated your SEEK Profile.',
      text: getProfileLink('nudge-thank-you-profile'),
      firstName,
      imageUrl: `data:image/svg+xml;base64,${profileImage}`
    };

    if (nudgePostError) {
      return <NudgeTemplate {...errorProps} />;
    }

    if (isThankYouMessage) {
      return <NudgeTemplate {...thanksProps} />;
    }

    return (
      <ScrollMonitor
        fullyEnterViewport={this.nudgeImpression({
          nudgeId: nudge.id,
          position: position + 1
        })}
      >
        <div>
          <NudgeTemplate {...{ ...baseTemplateProps, ...nudge }} />
        </div>
      </ScrollMonitor>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Nudge);
